import React, {Fragment, useState, useEffect} from 'react'
import {Button} from 'react-bootstrap'
import '../Overview.css'
import Modal from 'react-bootstrap/Modal'
import Forms from './Form'
import UserService from '../../../../../services/user'
import MasterService from '../../../../../services/master'
import useServices from '../../../../../utils/hooks/useServices'
import Dropdown from 'react-bootstrap/Dropdown'
import {toast} from 'react-toastify'
import Spinner from 'react-bootstrap/Spinner'
import {useSearchParams} from 'react-router-dom'
import MasterServices from '../../../../../services/master'
import {PageTitle} from '_metronic/layout/core'
import Pagination from 'react-bootstrap/Pagination'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const ThesisDisertation = () => {
  const [searchParams] = useSearchParams()
  const [show, setShow] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [formValue, setFormValue] = useState<any>({})
  const [data, setData] = useState<any>({})
  const [dataUser, loading, isError, triggerRefresh] = useServices(
    searchParams.get('alumni') ? MasterServices.showUser : UserService.getProfile,
    searchParams.get('alumni')
  )
  const [thesis, setThesis] = useState<any>([])

  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })

  useEffect(() => {
    if (searchParams.get('alumni')) {
      setData(dataUser?.data)
    } else {
      setData(dataUser)
    }
  }, [dataUser])

  useEffect(() => {
    getThesis({})
  }, [])

  const getThesis = async (param: any) => {
    try {
      const data = await MasterService.getThesisList(param)
      setThesis(data?.data)
    } catch (error) {
    }
  }

  const toggle = () => {
    if (show) {
      setIsEdit(false)
      setFormValue({})
    }
    setShow(!show)
  }

  const onChange = (e: any) => {
    const {name, value} = e.target

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })

    getThesis({page: to_page})
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      newTotal.push(total + 1)
    }

    return newTotal
  }

  const handleKeywrdsKeys = (data: any) => {
    let keywordKeys: any = []
    data?.map((item: any) => {
      keywordKeys.push({
        label: item.KataKunci,
        value: item.KataKunci,
      })
    })

    return keywordKeys
  }

  return (
    <div>
      <Modal show={show} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Form' : 'Form'} Tesis & Disertasi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {show && (
            <Forms
              onChange={onChange}
              toggle={toggle}
              getData={triggerRefresh}
              editFormValue={formValue}
            />
          )}
        </Modal.Body>
      </Modal>
      <div className='row'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-6'>
              {localStorage.getItem('role') == 'Alumni' && (
                <PageTitle
                  breadcrumbs={[
                    {
                      title: 'Dashboard',
                      path: '/dashboard',
                      isSeparator: false,
                      isActive: false,
                    },
                    {
                      title: '/',
                      path: '',
                      isSeparator: false,
                      isActive: false,
                    },
                  ]}
                >
                  Tesis & Disertasi
                </PageTitle>
              )}
              <h4>Tesis & Disertasi</h4>
            </div>
            <div className='col-md-6'>
              {!searchParams.get('alumni') && (
                <Button
                  onClick={toggle}
                  className='btn btn-primary btn-sm btn-add'
                  style={{float: 'right'}}
                >
                  Tambah
                </Button>
              )}
            </div>
          </div>
        </div>

        <div className='col-md-12 d-grid gap-10'>
          <div style={{textAlign: 'center'}}>
            {loading && (
              <Spinner animation='border' role='status' style={{height: '100px', width: '100px'}} />
            )}
            {!loading && thesis?.data?.length === 0 && <h3>Tidak ada data Tesis & Disertasi</h3>}
          </div>

          <div className='d-grid gap-10'>
            {thesis?.data?.map((item: any, key: any) => {
              return (
                <Fragment key={Math.random()}>
                  <div className='card-custom'>
                    <div className='row'>
                      <div className='col-md-6 p-2'>
                        <h5>{item?.JudulTugasAkhir}</h5>
                      </div>
                      <div className='col-md-6'>
                        {!searchParams.get('alumni') && (
                          <Dropdown>
                            <Dropdown.Toggle
                              id='dropdown-basic'
                              style={{float: 'right'}}
                              className='btn btn-primary btn-sm'
                            >
                              Aksi
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href='#/action-1'
                                onClick={() => {
                                  setIsEdit(true)
                                  setFormValue({
                                    JenisTugasAkhirId: item?.JenisTugasAkhirId,
                                    TemplateKetentuan: item?.TemplateKetentuan,
                                    BahasaId: item?.BahasaId,
                                    BidangKeilmuanId: item?.BidangKeilmuanId,
                                    JudulTugasAkhir: item?.JudulTugasAkhir,
                                    Abstrak: item?.Abstrak,
                                    TahunPublish: item?.TahunPublish,
                                    Author: item?.Author,
                                    publish_country: item?.publish_country,
                                    kata_kunci: handleKeywrdsKeys(item?.katakunci),
                                    rowDetail: item,
                                  })
                                  toggle()
                                }}
                              >
                                Lihat
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      </div>
                      <div className='col-md-12 p-2'>
                        <p>{item?.KodeRegistrasi || '-'}</p>
                      </div>

                      <div className='mt-6 col-md-12'>
                        {item?.katakunci?.map((value: any, key: any) => {
                          return (
                            <span key={key} className='badge badge-primary m-2 rounded-pill'>
                              {value?.KataKunci}
                            </span>
                          )
                        })}
                      </div>

                      {item?.Dokumen ? (
                        <div className='col-md-12 p-2'>
                          <p>Dokumen Pendukung</p>
                          <a
                            href={item?.Dokumen}
                            target='_blank'
                            className='btn btn-primary btn-sm mt-5'
                            rel='noreferrer'
                          >
                            Dokumen
                          </a>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Fragment>
              )
            })}
          </div>

          <div style={{float: 'right'}}>
            <Pagination>
              {generateTotalPage(thesis?.last_page)?.map((item: any) => {
                return (
                  <Pagination.Item
                    key={item}
                    active={item === pagination.page}
                    onClick={() => onChangePerPage(pagination.per_page, item)}
                  >
                    {item}
                  </Pagination.Item>
                )
              })}
            </Pagination>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ThesisDisertation
